module.exports = __webpack_public_path__ + "static/media/home_case1.dddd375f.jpg";